"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChoiceGroupWithImages_1 = require("./components/ChoiceGroupWithImages");
exports.ChoiceGroupWithImages = ChoiceGroupWithImages_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-choice-group-with-images/lib/index.js
// module id = 3737
// module chunks = 2